import { roundness } from "@provider/dripsy";
import { Text, View } from "dripsy";
import * as React from "react";

export const shimmerStyle = {
  backgroundColor: "$grey",
  width: 50,
  opacity: 0.3,
  height: 14,
  borderRadius: roundness,
};

function PriceLabel({
  label,
  value,
  isShimmering = false,
  color = "$textGrey",
}: {
  label: string;
  value: string | number;
  isShimmering?: boolean;
  color?: "$textGrey" | "$orange";
}) {
  return (
    <View
      sx={{
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <Text sx={{ fontWeight: "600", color }}>
        {label}
      </Text>
      <Text sx={isShimmering ? { ...shimmerStyle } : { fontWeight: "600", color }}>
        {isShimmering ? `` : value}
      </Text>
    </View>
  );
}
export default PriceLabel;
